// Announcements
export const ANNONCMENT_MONDAY = `We're happy to announce a new way to reach out for support! You'll now see a Support button at the bottom corner of your Illuminate screen.
Going forward, please use this button to submit any support tickets. It's the fastest way to get help with any issues or questions.`;

export const BRANCH_INFO_TEXT =
	"Branches indicate which location's data you are currently viewing. Switching branches updates all client, provider, and scheduling information accordingly.";

// Branch/State Configuration
// Maps state IDs to their display name and badge color for consistent UI across the application
export const BRANCH_STATE_CONFIG: Record<number, { color: 'primary' | 'success'; name: string }> = {
	1: { name: 'New York', color: 'success' },
	2: { name: 'North Carolina', color: 'primary' },
};

// Helper function to format branch name based on state ID
export const formatBranchName = (stateId: number): string => BRANCH_STATE_CONFIG[stateId]?.name || '';

// Helper function to get badge color type for a branch based on its state
export const getBranchBadgeType = (stateId: number): 'primary' | 'success' =>
	BRANCH_STATE_CONFIG[stateId]?.color || 'primary';
// Reports
export const REPORT_GENERATION_MESSAGE =
	'Generating your report... This usually takes just a few moments, but may take longer for larger datasets.';

export const DOWNLOAD_ALERT_TEXT =
	"This report may contain sessions in Pending BT status or marked 'Requires Date Change'. Please review the data before proceeding.";

// SOAP Notes
export const getEndSessionBtNote = (isDoeFunded: boolean): string =>
	`*Note: Please ensure you have taken data on at least ${isDoeFunded ? 2 : 3} goals per hour and recorded any behaviors observed`;

export const END_SESSION_NOTE =
	'The related session will be automatically concluded. Please ensure all necessary data has been gathered.';

// Dashboard
export const FLAGGED_SESSIONS_TITLE = 'Flagged Sessions';

export const FLAGGED_SESSIONS_DESCRIPTION = 'To make changes to a session, click the edit icon on the far right.';

// Calendar/Session Actions
export const DELETE_DESCRIPTION_SESSION = 'You are going to delete Session, are you sure?';

export const DELETE_DESCRIPTION_SOAP = 'You are going to delete SOAP note, are you sure?';

export const CONFIRM_ERROR_MESSAGE_ASSESMENT =
	'Assessment sessions can only be recorded by BCBAs within the final 5 weeks of the authorization period.';

export const DELETE_SESSION_BT_WARNING = 'Completed sessions cannot be deleted to preserve clinical records';

export const UNSAVED_TARGET_DATA_WARNING = 'Are you sure you want to leave? Targets with no data will not be saved.';

export const DSU_TIME_MISMATCH_WARNING =
	"Supervision time must fall within the BT's session. Please either adjust your DSU time to fit within the BT session, or contact the BT to adjust their session time.";

export const DSU_LOCATION_MISMATCH_ERROR = 'Please select a location same type as BT session';

export const BT_LOCATION_MISMATCH_ERROR = 'Please select a location same type as DSU session';

// Session Types — enum values match the backend SessionType enum (Type column).
// IMPORTANT: These are NOT DB row IDs. DOE session types have different DB IDs
// (e.g., DOE BT has id=12 but type=3). Always use the `type` field from the API
// response (SessionTypeProperties.type) to look up labels, never the `id` field.
export enum SessionType {
	Assessment = 1,
	TreatmentPlanning = 2,
	BehaviorTreatment = 3,
	DirectSupervision = 4,
	BehaviorTreatmentModification = 5,
	ParentTraining = 6,
	MeetAndGreet = 7,
	MeetAndGreetNonBillable = 8,
	DiscretionarySession = 9,
	BcbaBtIntroCall = 10,
}

export const SESSION_TYPE_LABELS: Record<number, string> = {
	[SessionType.Assessment]: 'Assessment',
	[SessionType.TreatmentPlanning]: 'Treatment Planning',
	[SessionType.BehaviorTreatment]: 'Behavior Treatment',
	[SessionType.DirectSupervision]: 'Direct Supervision',
	[SessionType.BehaviorTreatmentModification]: 'Behavior Treatment Modification',
	[SessionType.ParentTraining]: 'Parent Training',
	[SessionType.MeetAndGreet]: 'Meet and Greet',
	[SessionType.MeetAndGreetNonBillable]: 'Meet and Greet (Non-Billable)',
	[SessionType.DiscretionarySession]: 'Discretionary Session',
	[SessionType.BcbaBtIntroCall]: 'BCBA-BT Intro Call',
};

export const SESSION_TYPE_OPTIONS = Object.entries(SESSION_TYPE_LABELS).map(([id, name]) => ({
	id,
	name,
}));
